import styled from "styled-components";
import {colors, sizes, fontSize} from "../../../../themes";

export const HeaderWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-top: 16px;
  padding-bottom: 11px;
  @media only screen and ${sizes.max991} {
    padding-top: 3.2vw;
    padding-bottom: 2.2vw;
  }
`;

export const BackButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 7px;
  cursor: pointer;
  span {
    font-style: normal;
    font-weight: 700;
    ${fontSize(14)}
    line-height: 140%;
    color: ${colors.text.ebony};
  }
  svg {
    width: 24px;
  }
  @media only screen and ${sizes.max991} {
    gap: 1.4vw;
    svg {
      width: 5vw;
    }
  }
`;

export const Title = styled.div`
  font-style: normal;
  font-weight: 400;
  ${fontSize(16)}
  line-height: 120%;
  text-align: center;
  color: ${colors.text.ebony};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Duration = styled.strong`
  color: ${props => props.red ? '#EB5757' : '#0EA41D'};
  padding-left: 3px;
  padding-right: 3px;
`;

export const ExtendButton = styled.div`
  padding: 8px 12px;
  gap: 8px;
  background: #0EA41D;
  border-radius: 4px;
  margin-left: 19px;
  cursor: pointer;
  font-style: normal;
  font-weight: 600;
  ${fontSize(14)}
  line-height: 120%;
  text-align: center;
  color: #FFFFFF;
  @media only screen and ${sizes.max991} {
    margin-left: 3.8vw;
    padding: 1.6vw 2.4vw;
    gap: 1.6vw;
  }
`;
